import React from 'react'

import { cx } from '../../ui/utils'

// note: this enum is being referenced, not shadowed with the same name.

export enum ButtonVariationStyle {
  primary = 'btn-primary',
  outline = 'btn-outline',
  secondary = 'btn-secondary',
  secondary_outline = 'btn-outline btn-secondary',
  secondary_gray = 'btn-neutral',
  secondary_gray_outline = 'btn-neutral btn-outline',
  tertiary = 'tertiary',
  tertiary_outline = 'tertiary_outline',
  ghost = 'btn-ghost',
}

export enum ButtonSizeEnum {
  '2xs' = '2xs',
  xs = 'xs',
  sm = 'sm',
  lg = 'lg',
  xl = 'xl',
  '2xl' = '2xl',
  '4xl' = '4xl',
}

export enum ButtonType {
  button = 'button',
  submit = 'submit',
  reset = 'reset',
}

export interface ButtonProps {
  children?: React.ReactNode
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  ariaLabel?: string
  isDisabled?: boolean
  size?: keyof typeof ButtonSizeEnum
  type?: keyof typeof ButtonType
  variation?: keyof typeof ButtonVariationStyle
  rounded?: boolean
  success?: boolean
  warning?: boolean
  error?: boolean
  info?: boolean
  outline?: boolean
  className?: string
  icon?: React.ReactNode
  tabIndex?: number
}

export default function Button({
  children,
  handleClick,
  ariaLabel,
  size,
  isDisabled = false,
  type = 'button',
  variation,
  rounded,
  success,
  warning,
  error,
  info,
  outline,
  className,
  icon,
  tabIndex,
}: ButtonProps) {
  let outlineClass = ''
  if (variation === 'outline' && ButtonVariationStyle.outline) {
    if (success) {
      outlineClass = 'button-outline-success'
    } else if (warning) {
      outlineClass = 'button-outline-warning'
    } else if (error) {
      outlineClass = 'button-outline-danger'
    } else {
      outlineClass = 'button-outline'
    }
  }

  const buttonClass = cx(
    'btn',
    'text-base',

    outlineClass,
    // icon && !children && ''
    variation === 'primary' && ButtonVariationStyle.primary,
    variation === 'outline' && ButtonVariationStyle.outline,
    variation === 'secondary' && ButtonVariationStyle.secondary,
    variation === 'secondary_outline' && ButtonVariationStyle.secondary_outline,
    variation === 'secondary_gray' && ButtonVariationStyle.secondary_gray,
    variation === 'secondary_gray_outline' && ButtonVariationStyle.secondary_gray_outline,
    variation === 'tertiary' && ButtonVariationStyle.tertiary,
    variation === 'tertiary_outline' && ButtonVariationStyle.tertiary_outline,
    size && `btn-${size}`,
    rounded && 'button-rounded',
    success && 'btn-success',
    warning && 'btn-warning',
    error && 'btn-error',
    outline && 'btn-outline',
    info && 'btn-info',
    variation === 'ghost' && ButtonVariationStyle.ghost,
    className
  )

  return (
    <button
      tabIndex={tabIndex}
      type={type ?? 'button'}
      onClick={handleClick}
      disabled={Boolean(isDisabled)}
      aria-label={ariaLabel}
      className={cx(buttonClass)}
    >
      {icon && !children && <>{icon}</>}
      {!icon && children && <>{children}</>}
      {icon && children && (
        <div className="flex gap-2 p-1 items-center">
          {icon}

          {children}
        </div>
      )}
    </button>
  )
}
